import React from "react";
import { Link } from "react-router-dom";

const VendorResult = ({ vendor }) => {
  const { payee_id, ref, title, address, description, phone_number, email } = vendor;

  return (
    <div className="vendor-result p-3">
      {/* Header Section */}
      <div className="header mb-3">
        <h3 className="text-primary mb-1">{title}</h3>
        <p className="text-muted">{description || "No description provided"}</p>
      </div>

      {/* Details Section */}
      <div className="details mb-4">
        <div className="row">
          <div className="col-6">
            <strong className="d-block text-secondary">Vendor ID </strong>
            <span>{payee_id}</span>
          </div>
          <div className="col-6">
            <strong className="d-block text-secondary">Reference</strong>
            <span>{ref}</span>
          </div>
          <div className="col-6">
            <strong className="d-block text-secondary">Address</strong>
            <span>{address || "N/A"}</span>
          </div>
          <div className="col-6">
            <strong className="d-block text-secondary">Phone Number</strong>
            <span>{phone_number || "N/A"}</span>
          </div>
          <div className="col-6">
            <strong className="d-block text-secondary">Email</strong>
            <span>{email || "N/A"}</span>
          </div>
        </div>
      </div>

      {/* Action Buttons Section */}
      <div className="actions">
        <Link to={`/vendor/view/${payee_id}`} className="d-block mb-3 text-info">
          <i className="fas fa-file-alt mr-2"></i> Vendor Statement
        </Link>
        <Link to={`/vendor/edit/${payee_id}`} className="d-block mb-3 text-primary">
          <i className="fas fa-edit mr-2"></i> Edit Vendor
        </Link>
        <Link to={`/vendor/delete/${payee_id}`} className="d-block text-danger">
          <i className="fas fa-trash-alt mr-2"></i> Delete Vendor
        </Link>
      </div>
    </div>
  );
};

export default VendorResult;
